export interface StageOption {
  id: number;
  label: string;
}

export interface AssigneeOption {
  id: number;
  label: string;
}

export const STAGE_OPTIONS: StageOption[] = [
  { id: 1, label: "New" },
  { id: 2, label: "Contacted" },
  { id: 3, label: "Qualified" },
  { id: 4, label: "Proposal Sent" },
  { id: 5, label: "Negotiating" },
  { id: 6, label: "Closed - Won" },
  { id: 7, label: "Closed - Lost" },
  { id: 8, label: "Awaiting Customer" },
  { id: 9, label: "Virtual Site Visit Booked" },
  { id: 10, label: "Outreach - No Response" },
  { id: 11, label: "Installation Scheduled" },
];

export const ASSIGNEE_OPTIONS: AssigneeOption[] = [
  { id: 1, label: "Unassigned" },
  { id: 2, label: "Sarah Wilson" },
  { id: 3, label: "Albert Nerdo" },
  { id: 4, label: "John Smith" },
  { id: 5, label: "Emily Johnson" },
  { id: 6, label: "Michael Brown" },
];

export const STAGE_LABELS: { [key: number]: string } = STAGE_OPTIONS.reduce(
  (acc, stage) => {
    acc[stage.id] = stage.label;
    return acc;
  },
  {} as { [key: number]: string },
);

export const ASSIGNEE_LABELS: { [key: number]: string } =
  ASSIGNEE_OPTIONS.reduce(
    (acc, assignee) => {
      acc[assignee.id] = assignee.label;
      return acc;
    },
    {} as { [key: number]: string },
  );

export const getStageIdFromLabel = (stage: string): number => {
  const stageOption = STAGE_OPTIONS.find(
    (option) => option.label.toLowerCase() === stage.toLowerCase(),
  );
  return stageOption?.id || 1; // Default to "New" if not found
};

export const getStageLabelFromId = (id: number): string => {
  return STAGE_LABELS[id] || "New";
};

export const getAssigneeIdFromLabel = (assignee: string): number => {
  const assigneeOption = ASSIGNEE_OPTIONS.find(
    (option) => option.label.toLowerCase() === assignee.toLowerCase(),
  );
  return assigneeOption?.id || 1; // Default to "Unassigned" if not found
};

export const getAssigneeLabelFromId = (id: number): string => {
  return ASSIGNEE_LABELS[id] || "Unassigned";
};
